// Use word joiner for non-breaking hyphen because iOS bug causes regular non-breaking hyphens to render as underscores.
const wordjoiner = '\u2060';
export const nbh = `${wordjoiner}-${wordjoiner}`; // non breaking hyphen;
export const nbsp = '\u00a0'; // non breaking space;
